<div class="page has-breadcrumb has-title">
  <h1>{{ title }}</h1>
  <small>
    {{
      "Feedback received by this user in the marketplace. Please be kind and respectful in your comments." | translate
    }}
  </small>

  <div *ngIf="feedback !== undefined; else loadingTemplate">
    <astrobin-marketplace-feedback [feedback]="feedback"></astrobin-marketplace-feedback>
  </div>
</div>

<ng-template #loadingTemplate>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
